;(function ($, window) {
  'use strict'

  window.eah = window.eah || {}

  eah.mirrorImage = (function ($) {
    const initialize = function () {

      // $('body').on('click', '.js-mirrorImage', function(e) {
      //   e.preventDefault();
      //   var toggles = $(this).closest('.fancybox-wrap').find('.js-toggle');
      //
      //   toggles.toggleClass('is-toggled');
      // });
    }

    return {
      initialize: initialize
    }
  }())

  $(function () {
    // eah.mirrorImage.initialize()
  })
}(jQuery, window))
